<template>
  <div class="d-flex justify-content-between">
    <div class="rounded w-100 text-center p-1 mr-1 border">
      <div
        class="font-weight-bolder border-bottom"
        style="padding-bottom: 10px; margin-bottom: 10px"
      >
        Tekil Görüntüleme
      </div>
      <div class="font-medium-2 font-weight-bold">
        {{ dataItem.singular | toNumber }}
      </div>
    </div>
    <div class="border rounded w-100 text-center p-1 ml-1 border">
      <div
        class="font-weight-bolder border-bottom"
        style="padding-bottom: 10px; margin-bottom: 10px"
      >
        Toplam Görüntüleme
      </div>
      <div class="font-medium-2 font-weight-bold">
        {{ dataItem.plural | toNumber }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VisitCard',
  props: {
    dataItem: {
      type: Object,
      required: true,
    },
  },
}
</script>
